


































































































































































































































































































import {
  FormsApi,
  // ScrollBrand, // TODO enable when brands are readded.
  ScrollType,
  ScrollWeeks
} from "@/api";
import stateMixin from "@/mixins/state";

export default {
  data() {
    return {
      minimalDatePickerDate: "",
      minimalDatePickerSwallowDate: "",
      trueFalse: [
        {
          text: "Ja",
          value: true
        },
        {
          text: "Nee",
          value: false
        }
      ],
      scrollType: [
        {
          text: "Combidose",
          value: ScrollType.Combidose
        },
        {
          text: "Multidose",
          value: ScrollType.Multidose
        }
      ],
      scrollWeeks: [
        {
          text: "1 week",
          value: ScrollWeeks.OneWeek
        },
        {
          text: "2 weken",
          value: ScrollWeeks.TwoWeeks
        },
        {
          text: "3 weken",
          value: ScrollWeeks.ThreeWeeks
        },
        {
          text: "4 weken",
          value: ScrollWeeks.FourWeeks
        },
        {
          text: "Anders namelijk...",
          value: ScrollWeeks.Other
        }
      ],
      // scrollBrand: [
      //   {
      //     text: "Geen",
      //     value: ScrollBrand.None
      //   },
      //   {
      //     text: "Spencer",
      //     value: ScrollBrand.Spencer
      //   }
      // ],
      // TODO enable when brands are readded
      daysFile: [
        {
          text: "Maandag",
          value: "Maandag"
        },
        {
          text: "Dinsdag",
          value: "Dinsdag"
        },
        {
          text: "Woensdag",
          value: "Woensdag"
        },
        {
          text: "Donderdag",
          value: "Donderdag"
        },
        {
          text: "Vrijdag",
          value: "Vrijdag"
        }
      ],
      daysPharmacy: [
        {
          text: "Maandag",
          value: "Maandag"
        },
        {
          text: "Dinsdag",
          value: "Dinsdag"
        },
        {
          text: "Woensdag",
          value: "Woensdag"
        },
        {
          text: "Donderdag",
          value: "Donderdag"
        },
        {
          text: "Vrijdag",
          value: "Vrijdag"
        },
        {
          text: "Zaterdag",
          value: "Zaterdag"
        }
      ],
      desiredFirstDeliveryDateMenu: null,
      firstSwallowDateMenu: null,
      firstSwallowTimeMenu: null,
      valid: true,
      ScrollWeeks,
      fields: {
        name: "",
        replacesOtherDepartment: false,
        otherDepartmentName: "",
        facturation: "",
        patientAmount: 1,
        scrollWeeks: ScrollWeeks.OneWeek,
        amountWeeksOther: "",
        //scrollBrand: ScrollBrand.None, // TODO enable when brands are readded.
        scrollType: ScrollType.Combidose,
        packagingService: false,
        packagingType: "",
        administrationLists: null,
        pharmacyDeliveryDay: "",
        desiredFirstDeliveryDate: "",
        firstSwallowDate: "",
        firstSwallowTime: "",
        remarks: ""
      },
      requiredFields: ["stopDate"],
      rules: {
        name: [(v: string) => !!v || "Naam afdeling is verplicht"],
        otherDepartmentName: [
          v =>
            (!!v && this.fields.replacesOtherDepartment) ||
            "Naam bestaande afdeling is verplicht"
        ],
        replacesOtherDepartment: [v => v !== null || "Keuze is verplicht"],
        patientAmount: [v => !!v || "Aantal patienten is verplicht"],
        scrollWeeks: [v => !!v || "Weken is verplicht"],
        scrollType: [v => !!v || "Soort rol is verplicht"],
        //scrollBrand: [v => !!v || "Type rol is verplicht"], // TODO enable when brands are readded.
        packagingService: [v => v !== null || "Inpakservice is verplicht"],
        packagingType: [(v: string) => !!v || "Type inpakservice is verplicht"],
        administrationLists: [
          v =>
            (v !== null && this.fields.packagingService === true) ||
            "Toedienlijsten is verplicht"
        ],
        pharmacyDeliveryDay: [
          v => !!v || "Voorkeurslevering in apotheek is verplicht"
        ],
        amountWeeksOther: [
          (v: string) =>
            !!v || "Aantal weken is verplicht voor bij anders namelijk..."
        ]
      }
    };
  },

  mixins: [stateMixin],
  mounted() {
    this.setMinimalDatePickerDate();
  },
  methods: {
    submit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          const result = await api.formsRequestNewDepartment({
            ...this.fields
          });
          this.setState(this.states.COMPLETED);

          (this.$refs.form as HTMLFormElement).reset();
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    },
    setMinimalDatePickerDate: function() {
      const dateObject = new Date();
      // add 11 days (1.5 weeks)
      dateObject.setDate(dateObject.getDate() + 11);
      const isoString = dateObject.toISOString();
      this.minimalDatePickerDate = isoString.substring(0, 10);
    },
    allowedDates: function(val: number) {
      var dateObject = new Date(val);
      return dateObject.getDay() !== 0;
    }
  },
  computed: {
    getMinimalSwallowDate: function() {
      if (
        this.fields.desiredFirstDeliveryDate !== undefined &&
        this.fields.desiredFirstDeliveryDate !== null &&
        this.fields.desiredFirstDeliveryDate !== ""
      ) {
        const date = new Date(this.fields.desiredFirstDeliveryDate);
        //one day later
        date.setDate(date.getDate() + 1);
        var isoString = date.toISOString().substring(0, 10);
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.minimalDatePickerSwallowDate = isoString;
        return isoString;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.minimalDatePickerSwallowDate = "";
      return "";
    },
    firstSwallowDateRules() {
      if (
        this.fields.desiredFirstDeliveryDate &&
        this.fields.firstSwallowDate
      ) {
        const deliveryDate = new Date(this.fields.desiredFirstDeliveryDate);
        const swallowDate = new Date(this.fields.firstSwallowDate);
        const isValid = swallowDate > deliveryDate;
        return [
          isValid ||
            "De eerste slikdag dient minimaal een dag na de gewenste datum toezending eerste bestelling te zijn."
        ];
      }
      return [];
    }
  }
};
